import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { submenu } from './sub.menu';
import { CacheRouteReuseStrategy } from '@core/router/cache-reuse-strategy';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Monitoring,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Monitoring,
        title: marker('modules.monitoring.head'),
        loadChildren: () => import('./features/monitoring/monitoring.routes').then((r) => r.routes),
        canLoad: [AuthGuard],
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: CacheRouteReuseStrategy,
        },
    ],
})
export class AppRoutingModule {}
